import { render, staticRenderFns } from "./CourseEdit.vue?vue&type=template&id=f37f2a98&"
import script from "./CourseEdit.vue?vue&type=script&lang=js&"
export * from "./CourseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports